import React from 'react'
import moment from 'moment'

import { localizedStrings } from '@core/strings'
import { Box, Text } from '@fundamentals'
import { Card, CardProps } from '@common/material'
import { Palette } from '@core/theme/color-palette-siteassist'

type BriefingUserCardProps = CardProps & {
  title: string
  subtitle: string
  lastSignedOn?: string
  Icon?: React.ReactNode
  onClick?: () => void
}

export const BriefingUserCard: React.FC<BriefingUserCardProps> = ({
  title,
  subtitle,
  lastSignedOn,
  Icon,
  onClick,
  sx,
  ...props
}) => {
  return (
    <Card
      sx={{
        display: 'flex',
        p: 2,
        ...(onClick && {
          cursor: 'pointer',
          '&:hover': { bgcolor: Palette.Grey[50] },
        }),
        ...sx,
      }}
      onClick={onClick}
      {...props}
    >
      <Box flex={1}>
        <Text fontSize={15} fontWeight={500} color='text.primary'>
          {title}
        </Text>

        <Text fontSize={12} color='text.secondary' mt={0.5}>
          {subtitle}
        </Text>

        {!!lastSignedOn && (
          <Text fontSize={12} color='text.secondary' mt={0.5}>
            {`${localizedStrings.lastBriefed}: ${moment(lastSignedOn).format(
              'DD MMM YYYY HH:mm',
            )}`}
          </Text>
        )}
      </Box>

      {Icon && <Box ml={0.5}>{Icon}</Box>}
    </Card>
  )
}
